import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-xs font-medium tracking-widest uppercase text-secondary-500">
            浏览分类
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mt-3">
            分类精选
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-md mx-auto">
            涵盖恋爱、奇幻、动作、悬疑等八大热门分类，总有一款适合你
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70 transition-all hover:border-primary-300"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400">
                {cat.count}部
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}